import { useFieldArray, useFormContext } from "react-hook-form";
import { IUser } from "../../../types/Auth/user";
import PermissionTable from "./PermissionTable";
import { userPermissionValue } from "../../../utils/Permission/User";

const UserPermissionTable = () => {
  const { control, watch } = useFormContext<IUser>();
  const { fields, replace } = useFieldArray({
    control,
    name: "user_permission",
    keyName: "genId",
  });

  const watchFieldArray = watch("user_permission");

  const controlledFields = fields.map((field, index) => {
    return {
      ...field,
      ...(watchFieldArray &&
        watchFieldArray.length > 0 &&
        watchFieldArray[index]),
    };
  });

  const resetArrayHandler = () => {
    replace(userPermissionValue);
  };

  return (
    <PermissionTable
      module={"user_permission"}
      controlledFields={controlledFields}
      resetArrayHandler={resetArrayHandler}
    />
  );
};

export default UserPermissionTable;
